import IconLink from './component'
export { IconLink }
export default IconLink